module.exports = {"available":"disponivel","booked":"Reservada","occupied":"Ocupada","booked-occupied":"Reservada / Ocupada","used":"em utilização","until":"até","all-day":"todo o dia","page_over_total":"página {page} de {total}","room-name":"nome da sala","current-booking":"atual","next-booking":"próximo","unknown":"desconhecido","floors":"piso","today":"hoje","no_bookings":"nenhuma reunião agendada hoje.","no_information":"nenhuma informação.","description":"descrição","capacity":"capacidade","allocated":"Atribuída","booked-occupied-allocated":"Reservada / Ocupada / Atribuída"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/pt.json
// module id = kMoD
// module chunks = 2